import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Reward icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Reward } from '@sravni/design-system-icons'
 *
 * <Reward />
 * ```
 */
var Reward = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Reward", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "m10 12.403 1.67.879a.443.443 0 0 0 .644-.468l-.319-1.86 1.353-1.317a.443.443 0 0 0-.246-.757l-1.869-.272-.835-1.694a.444.444 0 0 0-.796 0l-.835 1.694-1.869.272a.443.443 0 0 0-.245.757l1.352 1.316-.32 1.861a.443.443 0 0 0 .644.468l1.672-.879h-.002Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.917 10H17M3 10h-.917M15.717 4.283l-.875.875M4.3 15.742l.883-.884M4.283 4.3l.875.883M15.742 15.717l-.884-.875M10 17.033v.884M10 2.083v.884", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Reward };
//# sourceMappingURL=Reward.js.map
